export default __webpack_public_path__ + "assets/images/callback-summer-9b557d14.png";